import axios from 'axios';
import { URLS } from '../utils/urls';
let hasAuth = false;

const api = axios.create({
    baseURL: URLS.baseApi,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        if (global.auth_token) {
            config.headers.Authorization = `Bearer ${global.auth_token}`;
            hasAuth = true;
        }
        if (config?.baseURL) {
            config.baseURL = config?.baseURL
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject(error);
    }
);

export default api;